import { Component } from 'solid-js'
import GenerateImageOptionButton from './GenerateImageOptionButton'

const GenerateImageActionOptions: Component<{
  updatePrompt: (value: string, replacePrompt: boolean) => void
}> = (props) => {
  return (
    <div class="flex flex-row flex-wrap gap-4">
      <GenerateImageOptionButton title="Standing" value="standing" onClick={props.updatePrompt} />
      <GenerateImageOptionButton title="Sitting" value="sitting" onClick={props.updatePrompt} />
      <GenerateImageOptionButton title="Squatting" value="squatting" onClick={props.updatePrompt} />
      <GenerateImageOptionButton
        title="Lying down"
        value="lying down"
        onClick={props.updatePrompt}
      />
      <GenerateImageOptionButton
        title="Working Out"
        value="working out"
        onClick={props.updatePrompt}
      />
      <GenerateImageOptionButton title="Swimming" value="swimming" onClick={props.updatePrompt} />
      <GenerateImageOptionButton
        title="Playing Soccer"
        value="playing soccer"
        onClick={props.updatePrompt}
      />
    </div>
  )
}

export default GenerateImageActionOptions
